import React, { useState } from "react";
import TimeCarousel from "./TimeCarousel";
import "./Culture.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import image1 from "../../assets/Teamwork.jpg";
import image2 from "../../assets/oc1.svg";
import { Link } from "react-router-dom";
import CulLastSection from "./CulLastSectino";

const Culturepage = () => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div className="culture-page">
      <section
        className="hero container"
        style={{ display: "flex", gap: "150px", alignItems: "center" }}
      >
        <div className="mb-4">
          <h1
            className="display-4 fw-bold"
            style={{ fontFamily: "Montserrat-Regular" }}
          >
            <span style={{ color: "#411860" }}>
              Where Purpose Meets People.
              <br />
            </span>
          </h1>
          <p className="text-secondary mt-3">Our culture is built on the belief that transformation isn’t just an event—it’s an evolution driven by curiosity and precision.
We foster an environment where every challenge is met with an insatiable desire to explore the "why" behind the problem, ensuring we never settle for the obvious or the temporary.
By blending this relentless inquiry with a commitment to meticulous execution, we turn visionary ideas into sustainable, high-impact realities that grow alongside our partners.</p>
        </div>

        <div className="d-flex justify-content-center align-items-center">
          <div
            className="position-relative"
            style={{ display: "inline-block" }}
          >
            <img
              src={image1}
              alt="Teamwork"
              className="img-fluid rounded shadow"
              style={{ maxWidth: "450px" }}
            />
            <span
              className="position-absolute top-50"
              style={{
                left: "-30px",
                transform: "translateY(100%)",
                width: "50px",
                height: "50px",
                backgroundColor: "#fff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2,
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <i
                className={`bi ${isHovered ? "bi-heart-fill" : "bi-heart"}`}
                style={{ color: "#e63946", fontSize: "20px" }}
              ></i>
            </span>
          </div>
        </div>
      </section>

      <div className="container" style={{ fontFamily: "Montserrat-Regular" }}>
        <TimeCarousel />
      </div>

      <div
        className="container my-5"
        style={{ fontFamily: "Montserrat-Regular" }}
      >
        <div className="insider_heading">
  <p className="text-uppercase text-muted small" style={{ color: '#6e0e5e'}}>Inside BluKraft</p>
          <h2 className="fw-bold mb-3"style={{ color: '#6e0e5e'}}>
            Innovation That Inspires <br />
            <span className="fw-bold"style={{ color: '#6e0e5e'}}>Ownership With Accountability.</span>
          </h2>
        </div>
        <div className="row d-flex align-items-center">
          <div className="col-md-6 d-flex flex-row gap-3">
            <div className="image-wrapper large-image">
              <img
                src={image2}
                alt="Team Discussion"
                className="img-fluid rounded shadow"
              />
            </div>
            <div
              className="image-wrapper small-image"
              style={{ paddingTop: "3.9rem" }}
            >
              <div className="position-relative">
                <span
                  className="position-absolute top-50"
                  style={{
                    right: "-17px",
                    transform: "translateY(30%)",
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 2,
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <i
                    className={`bi ${isHovered ? "bi-heart-fill" : "bi-heart"}`}
                    style={{
                      color: "#e63946",
                      fontSize: "20px",
                      marginTop: "0.3rem",
                    }}
                  ></i>
                </span>
                <img
                  src={image1}
                  alt="Work Culture"
                  className="img-fluid rounded shadow"
                />
              </div>
            </div>
          </div>

          <div className="col-md-6 text-start mt-4 mt-md-0">
            <h5 className="fw-bold mb-3">A Workplace That Cares </h5>
            <p className="text-secondary mb-4">
              We believe in balance - where ambition and well-being coexist.
              From flexible work approaches to mental wellness support, we
              ensure our people are cared for, heard, and valued. We celebrate
              wins, support challenges, and grow together -like a family that
              chooses each other every day.
            </p>
            {/* <Link to="#" className="text-danger fw-bold text-decoration-none">
              Explore →
            </Link> */}
          </div>
        </div>
      </div>

      <CulLastSection />
    </div>
  );
};

export default Culturepage;
